import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC_GgB1faklwt_4k0oy-4MRU9j-aNzSB7E",
  authDomain: "cassesanlorenzo.firebaseapp.com",
  projectId: "cassesanlorenzo",
  storageBucket: "cassesanlorenzo.appspot.com",
  messagingSenderId: "1068481891745"
};

//
// const app = initializeApp(firebaseConfig);

export const app = initializeApp(firebaseConfig); // Export the app object
export const db = initializeFirestore(app, {
  // Safari/proxy/privacy filters can block Firestore WebChannel (Listen/channel).
  // Force long polling to make realtime listeners stable in constrained networks.
  experimentalForceLongPolling: true,
  useFetchStreams: false
});
export const auth = getAuth(app);